import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import useUser from "../hook/useUser.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FaBell } from "react-icons/fa";

const Header = () => {
    const navigate = useNavigate();
    const { user } = useUser();
    const [hasUnreadNotification, setHasUnreadNotification] = useState(false);

    const latestUpdateMs = useMemo(() => {
        const quizUpdatedAt = user?.quizResult?.updatedAt;
        const feedbackUpdatedAt = user?.feedbacks?.updatedAt || user?.feedbacks?.createdAt;

        const quizMs = quizUpdatedAt ? new Date(quizUpdatedAt).getTime() : 0;
        const feedbackMs = feedbackUpdatedAt ? new Date(feedbackUpdatedAt).getTime() : 0;

        return Math.max(quizMs, feedbackMs);
    }, [user]);

    useEffect(() => {
        if (!user?.employeeId || !latestUpdateMs) {
            setHasUnreadNotification(false);
            return;
        }

        const storageKey = `notification:lastSeen:${user.employeeId}`;
        const lastSeenMs = Number(localStorage.getItem(storageKey) || 0);
        setHasUnreadNotification(latestUpdateMs > lastSeenMs);
    }, [user, latestUpdateMs]);

    const handleNotificationClick = () => {
        if (user?.employeeId && latestUpdateMs) {
            const storageKey = `notification:lastSeen:${user.employeeId}`;
            localStorage.setItem(storageKey, String(latestUpdateMs));
        }
        setHasUnreadNotification(false);
        navigate("/dashboard/notification");
    };

    return (
        <>
            <div className="header">
                <div className="header-left">
                    <img
                        src="/images/logo-brown.png"
                        className="header-logo"
                        alt="logo"
                        onClick={() => navigate("/dashboard/dashboard-nav")}
                        style={{ cursor: "pointer" }}
                    />
                    <img src="/images/brevia-brown.png" className="header-app-name" alt="app-name" />
                </div>

                <div className="header-right">
                    <button type="button" className="header-notification-wrapper" onClick={handleNotificationClick}
                        style={{ cursor: "pointer" }}>
                        <FaBell className="header-notification" />
                        {hasUnreadNotification &&
                            <span className="header-notification-dot" />}
                    </button>

                    <FontAwesomeIcon icon={faUser}
                        className="header-profile-icon"
                        onClick={() => navigate("/profile")}
                        style={{ cursor: "pointer" }}
                    />

                    {/* <img
                        src="/images/profile-1.png"
                        className="header-profile-logo"
                        alt="profile-logo"
                        onClick={() => navigate("/profile")}
                        style={{ cursor: "pointer" }}
                    /> */}
                </div>

            </div>
        </>
    )
}

export default Header;